export const coveredPeriod = `
query CoveredPeriod(
$criteria:ConfigurationCriteria
){
  coveredPeriod (criteria: $criteria) {
    start
    end
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/covered-period.js